import { render, staticRenderFns } from "./NeedChangePass.vue?vue&type=template&id=bff1d31c"
import script from "./NeedChangePass.vue?vue&type=script&lang=js"
export * from "./NeedChangePass.vue?vue&type=script&lang=js"
import style0 from "./NeedChangePass.vue?vue&type=style&index=0&id=bff1d31c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports